import { createSlice } from "@reduxjs/toolkit";

import { ILockScreenState } from "./types";
import { LOCAL_STORAGE_LOCK_SCREEN } from "../../constants/localStorageKeys";

const getLockScreenInfo = () => {
  const lock = localStorage.getItem(LOCAL_STORAGE_LOCK_SCREEN);
  if (!lock) {
    return null;
  }
  return JSON.parse(lock);
};

const LockScreenInfo: { lock: boolean } = getLockScreenInfo();

export const initialState: ILockScreenState = {
  lock: LockScreenInfo?.lock,
};

export const lockScreenSlice = createSlice({
  name: "lockScreenSlice",
  initialState,
  reducers: {
    lockScreenAction: (state, action) => {
      action.payload
        ? localStorage.setItem(
            LOCAL_STORAGE_LOCK_SCREEN,
            JSON.stringify({ lock: action.payload })
          )
        : localStorage.removeItem(LOCAL_STORAGE_LOCK_SCREEN);
      state.lock = action.payload;
    },
  },
});

export const { lockScreenAction } = lockScreenSlice.actions;

export default lockScreenSlice.reducer;
